import { useEffect, useState } from 'react';

/** True once the page has scrolled past `threshold` px. Drives the header state. */
export function useScrolled(threshold = 12): boolean {
  const [scrolled, setScrolled] = useState(() => window.scrollY > threshold);

  useEffect(() => {
    let frame = 0;

    const onScroll = () => {
      if (frame) return; // coalesce bursts of scroll events into one read per frame
      frame = requestAnimationFrame(() => {
        frame = 0;
        setScrolled(window.scrollY > threshold);
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (frame) cancelAnimationFrame(frame);
    };
  }, [threshold]);

  return scrolled;
}
